// Landing section on the partner programme (`/partner` in the dashboard): open
// to every account, `?partner=` link with 30-day attribution, 30% of our net fee
// on every payment the referred merchants take, for life, withdrawn in USDT/USDC.
// The rate is the admin "partner fee schedule" — keep the copy in sync with it.

const STEPS = [
  {
    title: "Get your link",
    desc: "Every PawPayments account has one in the Partner section of the dashboard. No application.",
  },
  {
    title: "Share it",
    desc: "Anyone who signs up within 30 days of opening it is yours, with every merchant they create.",
  },
  {
    title: "Earn and withdraw",
    desc: "Your 30% builds up on its own balance with every payment they take. Withdraw in USDT or USDC.",
  },
];

const BARS = [18, 26, 22, 34, 30, 42, 38, 52, 47, 60, 56, 72];

// Decorative partner-dashboard preview: referral link, stats, earnings bars.
function PartnerMock() {
  return (
    <div aria-hidden="true" className="relative w-full max-w-[440px] mx-auto lg:mx-0 select-none">
      <div className="absolute inset-[-40px] rounded-full bg-[rgba(0,121,236,0.14)] blur-[90px] pointer-events-none" />
      <div className="relative rounded-[24px] border border-white/[0.09] bg-[#030b14]/90 p-6 shadow-[0_30px_80px_rgba(0,0,0,0.55)] backdrop-blur-[17.5px]">
        <div className="flex items-center justify-between text-[13px] text-white/45">
          <span>Your referral link</span>
          <span className="text-[#77BDFF]">30% for life</span>
        </div>
        <div className="mt-2 flex items-center justify-between gap-3 rounded-xl border border-white/[0.08] bg-black/30 px-4 h-12 text-sm text-white/80">
          <span className="truncate">pawpayments.com/?partner=7f3a9c</span>
          <svg className="w-4 h-4 shrink-0 text-[#77BDFF]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <rect x="8" y="8" width="12" height="12" rx="2.5" />
            <path d="M16 8V6.5A2.5 2.5 0 0013.5 4h-7A2.5 2.5 0 004 6.5v7A2.5 2.5 0 006.5 16H8" />
          </svg>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3">
          <div className="rounded-xl border border-white/[0.07] bg-white/[0.03] p-4">
            <div className="text-[12px] text-white/45">Referred merchants</div>
            <div className="mt-1 text-white text-2xl font-medium">12</div>
          </div>
          <div className="rounded-xl border border-white/[0.07] bg-white/[0.03] p-4">
            <div className="text-[12px] text-white/45">Total earned</div>
            <div className="mt-1 text-white text-2xl font-medium">$1,284.50</div>
          </div>
        </div>

        <div className="mt-6 flex items-end gap-1.5 h-[72px]">
          {BARS.map((h, i) => (
            <span
              key={i}
              className="flex-1 rounded-t-[4px] bg-gradient-to-t from-[#0079ec]/40 to-[#77BDFF]"
              style={{ height: `${h}px`, opacity: 0.45 + (i / BARS.length) * 0.55 }}
            />
          ))}
        </div>

        <div className="mt-6 h-[48px] rounded-xl border border-[#0079ec]/50 bg-[#0079ec]/10 text-white text-sm font-medium flex items-center justify-center gap-2">
          Withdraw in USDT or USDC
        </div>
      </div>
    </div>
  );
}

export default function PartnerProgram() {
  return (
    <section className="mb-20 md:mb-40" id="partners">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_440px] gap-12 lg:gap-16 items-center">
          <div className="flex flex-col gap-8 scroll">
            <div className="flex flex-col gap-5">
              <h2 className="text-white text-3xl md:text-4xl lg:text-[48px] font-medium leading-[1.05]">
                Bring merchants.
                <br />
                Earn 30% for life.
              </h2>
              <p className="text-white/50 text-base md:text-lg leading-[1.4] max-w-[560px]">
                Know businesses that should take crypto? Send them your link: you get 30% of what we
                earn on every payment they take, for as long as they process with us. They pay
                nothing extra.
              </p>
            </div>

            <ol className="flex flex-col gap-5">
              {STEPS.map((s, i) => (
                <li key={s.title} className="flex gap-4">
                  <span className="w-9 h-9 shrink-0 rounded-full border border-[#0079ec]/60 text-[#77BDFF] text-sm font-medium flex items-center justify-center">
                    {i + 1}
                  </span>
                  <div className="flex flex-col gap-1">
                    <h3 className="text-white text-lg font-medium">{s.title}</h3>
                    <p className="text-white/45 text-sm leading-normal max-w-[480px]">{s.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <a
              href="/auth"
              className="self-start inline-flex items-center justify-center gap-2.5 bg-[#0079ec] text-white text-base font-medium px-6 h-[52px] rounded-xl shadow-[0_0_40px_rgba(0,121,236,0.35)] hover:bg-[#0069d0] transition-colors"
            >
              Get your partner link
              <svg className="w-[18px] h-[18px]" viewBox="0 0 20 19" fill="none" aria-hidden="true">
                <path
                  d="M13.149 3.717L11.87 5.096 14.834 8.261 2.5 8.274 2.502 10.218 14.803 10.206 11.888 13.346 13.173 14.717 18.29 9.204z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </div>

          <div className="scroll">
            <PartnerMock />
          </div>
        </div>
      </div>
    </section>
  );
}
